module.exports = __webpack_public_path__ + "img/close_icon_grey.b827beef.svg";